module.exports = __webpack_public_path__ + "img/phone-qr.8aa27782.png";